import { colors } from '../../../../../packages';

export const sx = {
  drawer: {
    '& .drawerBody': {
      padding: '0 !important',
      height: '100% !important',
    },
    '& .MuiDrawer-paper': {
      width: '480px !important',
      maxWidth: '100% !important',
    },
  },
  wrapper: {
    display: 'flex !important',
    flexDirection: 'column !important',
    height: '100% !important',
    minHeight: '100vh !important',
  },
  header: {
    display: 'flex !important',
    justifyContent: 'space-between !important',
    alignItems: 'center !important',
    height: '80px !important',
    padding: '20px 24px !important',
    borderBottom: `1px solid ${colors.neutral100} !important`,
    flexShrink: '0 !important',
  },
  headerTitle: {
    fontSize: '24px !important',
    lineHeight: '32px !important',
    fontWeight: '700 !important',
  },
  footer: {
    display: 'flex !important',
    justifyContent: 'space-between !important',
    alignItems: 'center !important',
    height: '80px !important',
    padding: '16px 24px !important',
    borderTop: `1px solid ${colors.neutral100} !important`,
    flexShrink: '0 !important',
  },
  backBtn: {
    width: '40px !important',
    height: '40px !important',
    minWidth: '40px !important',
  },
  form: {
    height: '100% !important',
    '& form': {
      display: 'flex !important',
      flexDirection: 'column !important',
      height: '100% !important',
      flex: '1 1 auto !important',
    },
  },
  formContent: {
    padding: '24px',
    overflowY: 'auto',
    flex: '1 1 auto',
  },
  section: {
    display: 'flex',
    flexDirection: 'column !important',
    gap: '12px',
  },
};
